/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'cash-multiple': {
    width: 24,
    height: 24,
    viewBox: '0 2 24 24',
    data: '<path pid="0" d="M5 6h18v12H5V6m9 3a3 3 0 013 3 3 3 0 01-3 3 3 3 0 01-3-3 3 3 0 013-3M9 8a2 2 0 01-2 2v4a2 2 0 012 2h10a2 2 0 012-2v-4a2 2 0 01-2-2H9m-8 2h2v10h16v2H1V10z"/>'
  }
})
